import { useEffect, useState } from "react";
import { viewFromApi } from "@/components/FileViewer";
import { FileCheck2, ChevronDown, ChevronUp, Eye, Clock } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function TeacherExcuseNotes({ classId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/teacher/excuse-notes", { params: { class_id: classId } }).then(({ data: d }) => alive && setData(d)).catch(() => {});
    load();
    const iv = setInterval(load, 30000);
    return () => { alive = false; clearInterval(iv); };
  }, [classId]);

  const openFile = (id) => viewFromApi(api, `/teacher/excuse-notes/${id}/file`, { title: "Excuse note" });

  if (!data) return null;
  const n = data.excuses.length;

  return (
    <div className="border-b border-slate-100" data-testid="teacher-excuse-notes">
      <button onClick={() => setOpen((o) => !o)} data-testid="teacher-excuse-toggle" className="w-full flex items-center justify-between gap-3 px-5 py-2.5 bg-indigo-50/50 text-left hover:bg-indigo-50 transition">
        <span className="inline-flex items-center gap-2 text-xs font-semibold text-indigo-900">
          <FileCheck2 className="h-4 w-4 text-indigo-700" /> Excused absences · {n} note{n === 1 ? "" : "s"} (last 90 days)
          {data.pending > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 px-2 py-0.5 text-[10px] font-semibold" data-testid="teacher-excuse-pending"><Clock className="h-3 w-3" /> {data.pending} awaiting office review</span>}
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-indigo-700" /> : <ChevronDown className="h-4 w-4 text-indigo-700" />}
      </button>
      {open && (
        <div className="max-h-72 overflow-y-auto">
          {n === 0 && <div className="px-5 py-4 text-xs text-slate-400" data-testid="teacher-excuse-empty">No excused absences on file for this class.</div>}
          <ul className="divide-y divide-slate-100">
            {data.excuses.map((e) => (
              <li key={e.id} className="px-5 py-2.5 flex items-center gap-3 text-sm" data-testid={`teacher-excuse-${e.id}`}>
                <span className="w-24 shrink-0 text-xs font-semibold text-slate-700 tabular-nums">{new Date(e.date + "T12:00:00").toLocaleDateString([], { month: "short", day: "numeric", year: "2-digit" })}</span>
                <span className="w-40 shrink-0 font-medium text-slate-900 truncate">{e.student_name}</span>
                <span className="flex-1 min-w-0 text-xs text-slate-600 truncate" title={e.note}>{e.note || "—"}</span>
                <span className="hidden sm:block text-[11px] text-slate-400 whitespace-nowrap">{e.created_by_name}</span>
                {e.has_doc && <button onClick={() => openFile(e.id)} data-testid={`teacher-excuse-file-${e.id}`} title="View note" className="h-7 w-7 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-primary inline-flex items-center justify-center"><Eye className="h-4 w-4" /></button>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
